import React from 'react';
import { Typography } from "@material-tailwind/react";

const TitleComponent = ({ Title, Subtitle }) => {
  return (
    <>
      <div className="flex w-full lg:px-[15%] items-center rounded-full mt-4">
        <div className="flex-1 border-b border-customMaroon-70"></div>
        <span className="uppercase  lg:text-[2rem] text-[1.3rem] text-gray-800 leading-8 px-4 md:px-8 py-3 title_DMSerifText-Regular">
          {Title}
        </span>
        <div className="flex-1 border-b border-customMaroon-70"></div>
      </div>
      <Typography className="text-center description_AlegreyaSans-Light lg:px-28 leading-tight">
        {Subtitle}
      </Typography>
    </>
  );
};

export default TitleComponent;